"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'limits.anti-hallucination.disabled': 'La función anti-alucinación no está disponible en su plan actual.',
};
